import type { DistanceSystem$options } from '$houdini';
import * as m from '$paraglide/messages';

const distanceSystemLabel: Record<DistanceSystem$options, () => string> = {
	IMPERIAL: m.itinerary__options__units__imperial,
	METRIC: m.itinerary__options__units__metric,
};
export function distanceSystems(constraint: DistanceSystem$options): string {
	return distanceSystemLabel[constraint]();
}
